import { observable } from 'mobx';
import { createContext } from 'react';

const GoalStore = observable({
  goals: [],
  hasSavingDeposit: true,
});

GoalStore.setValue = function(name, value) {
  this[name] = value;
};

GoalStore.addGoal = function(name) {
  this.goals.push({
    name: name,
    description: '',
    amount: 1000,
    years: 1,
  });
};

GoalStore.removeGoal = function(name) {
  this.goals = this.goals.filter(function(value, index, arr) {
    return value.name !== name;
  });
};

GoalStore.setSaving = function(value) {
  this.hasSavingDeposit = value;
};

GoalStore.setDetailGoal = function(name, property, value) {
  this.goals.find(x => x.name === name)[property] = value;
  //   const aux = this.goals.find(x => x.name === name);
};
const GoalStoreContext = createContext(GoalStore);

export default GoalStoreContext;
